// HomeScreen.js - ফিক্সড ভার্সন
import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import Icon from 'react-native-vector-icons/MaterialIcons';

const {width} = Dimensions.get('window');

const HomeScreen = () => {
  const navigation = useNavigation();

  const menuItems = [
    {id: 1, title: 'দৈনিক বোর্ড', icon: 'event-note', color: '#FF6B6B'},
    {id: 2, title: 'জি.আর শাখা', icon: 'gavel', color: '#4ECDC4'},
    {id: 3, title: 'আদালত কার্যতালিকা', icon: 'list-alt', color: '#45B7D1'},
    {id: 4, title: 'বদলী মামলা', icon: 'swap-horiz', color: '#FFA07A'},
  ];

  const quickServices = [
    {id: 1, title: 'আমার ডায়েরী', icon: 'book', screen: 'DiaryScreen'},
    {
      id: 2,
      title: 'নোটিফিকেশন',
      icon: 'notifications',
      screen: 'NotificationScreen',
    },
    {id: 3, title: 'নির্দেশিকা', icon: 'info', screen: 'GuidelineScreen'},
    {id: 4, title: 'যোগাযোগ', icon: 'phone', screen: 'ContactScreen'},
  ];

  return (
    <ScrollView
      style={styles.container}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={styles.scrollContent}
    >
      {/* Header */}
      <View style={styles.header}>
        <View>
          <Text style={styles.welcomeText}>স্বাগতম!</Text>
          <Text style={styles.userName}>বিডি জজ কোর্ট পোর্টাল</Text>
        </View>
        <TouchableOpacity style={styles.notificationIcon} activeOpacity={0.7}>
          <Icon name="notifications" size={28} color="#fff" />
          <View style={styles.notificationBadge}>
            <Text style={styles.badgeText}>3</Text>
          </View>
        </TouchableOpacity>
      </View>
      <View style={styles.container_body}>
        {/* Quick Action Cards */}
        <View style={styles.quickActions}>
          {menuItems.map(item => (
            <TouchableOpacity
              key={item.id}
              style={styles.quickActionCard}
              activeOpacity={0.8}
            >
              <View
                style={[styles.iconContainer, {backgroundColor: item.color}]}
              >
                <Icon name={item.icon} size={28} color="#fff" />
              </View>
              <Text style={styles.quickActionText} numberOfLines={2}>
                {item.title}
              </Text>
            </TouchableOpacity>
          ))}
        </View>

        {/* Quick Services */}
        <View style={styles.servicesSection}>
          <Text style={styles.sectionTitle}>দ্রুত সেবা</Text>
          <View style={styles.servicesGrid}>
            {quickServices.map(service => (
              <TouchableOpacity
                key={service.id}
                style={styles.serviceCard}
                onPress={() => navigation.navigate(service.screen)}
                activeOpacity={0.7}
              >
                <View style={styles.serviceIconContainer}>
                  <Icon name={service.icon} size={28} color="#307ecc" />
                </View>
                <Text style={styles.serviceText}>{service.title}</Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>

        {/* Latest Updates */}
        <View style={styles.updatesSection}>
          <Text style={styles.sectionTitle}>সর্বশেষ আপডেট</Text>
          <View style={styles.updateCard}>
            <Text style={styles.updateTitle}>অটো এসএমএস সার্ভিস চালু</Text>
            <Text style={styles.updateDate}>২৫ জানুয়ারি ২০২৬</Text>
            <Text style={styles.updateDesc}>
              মামলার ধার্য তারিখের ২৪ ঘন্টা পূর্বে এসএমএসের মাধ্যমে
              বাদী-বিবাদীকে জানানোর ব্যবস্থা চালু
            </Text>
          </View>
          <View style={styles.updateCard}>
            <Text style={styles.updateTitle}>নতুন ই-ফ্যামিলি কোর্ট</Text>
            <Text style={styles.updateDate}>২৪ জানুয়ারি ২০২৬</Text>
            <Text style={styles.updateDesc}>
              ঢাকায় প্রথম সম্পূর্ণ কাগজবিহীন ই-ফ্যামিলি কোর্ট চালু হয়েছে
            </Text>
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
    // paddingHorizontal: 40,
  },
  container_body: {
    paddingHorizontal: 40,
  },
  scrollContent: {
    paddingBottom: 30,
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 10,
    paddingTop: 10,
    paddingLeft: 40,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  welcomeText: {
    color: '#fff',
    fontSize: 14,
    opacity: 0.9,
  },
  userName: {
    color: '#fff',
    fontSize: 22,
    fontWeight: 'bold',
    marginTop: 4,
  },
  notificationIcon: {
    position: 'relative',
    padding: 4,
  },
  notificationBadge: {
    position: 'absolute',
    right: -2,
    top: -2,
    backgroundColor: '#FF4444',
    borderRadius: 10,
    width: 20,
    height: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  badgeText: {
    color: '#fff',
    fontSize: 11,
    fontWeight: 'bold',
  },
  quickActions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingHorizontal: 15,
    paddingTop: 15,
    marginTop: -20,
  },
  quickActionCard: {
    backgroundColor: '#fff',
    width: (width - 130) / 2,
    paddingVertical: 16,
    paddingHorizontal: 10,
    borderRadius: 12,
    alignItems: 'center',
    marginBottom: 10,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    minHeight: 100,
  },
  iconContainer: {
    width: 55,
    height: 55,
    borderRadius: 28,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 6,
  },
  quickActionText: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    textAlign: 'center',
  },
  servicesSection: {
    padding: 15,
    backgroundColor: '#fff',
    marginTop: 5,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 15,
  },
  servicesGrid: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  serviceCard: {
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    minWidth: 60,
  },
  serviceIconContainer: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: '#e8f0fe',
    justifyContent: 'center',
    alignItems: 'center',
  },
  serviceText: {
    fontSize: 12,
    color: '#333',
    marginTop: 5,
    fontWeight: '500',
    textAlign: 'center',
  },
  updatesSection: {
    padding: 15,
    backgroundColor: '#fff',
    marginTop: 5,
    marginBottom: 10,
  },
  updateCard: {
    backgroundColor: '#f8f9fa',
    padding: 15,
    borderRadius: 10,
    marginBottom: 10,
    borderLeftWidth: 4,
    borderLeftColor: '#307ecc',
  },
  updateTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  updateDate: {
    fontSize: 12,
    color: '#666',
    marginTop: 3,
  },
  updateDesc: {
    fontSize: 14,
    color: '#555',
    marginTop: 5,
    lineHeight: 20,
  },
});

export default HomeScreen;
